export const ResetPassword = () => {
  return <div>ResetPassword</div>;
};
